<template>
    <div>
        <v-card class="activity-log-container">
            <p class="mb-4 content-header">
                {{ this.$vuetify.lang.t('$vuetify.blacklist.activityLog') }}
            </p>
            <div v-for="(item, index) in logItems" :key="index">
                <div class="mb-2">
                    <div class="d-flex align-center">
                        <div class="circle-orange"></div>
                        <span class="date-time-log">{{item.datetime}}</span>
                    </div>
                    <div class="detail-log">
                        {{item.description}}
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'ActivityLog',

    props: {
        logItems: {
            type: Array,
            default: null
        }
    }
}
</script>

<style lang="scss" scoped>
.activity-log-container {
    border-radius: 15px;
    padding: 36px 54px;
}

.circle-orange {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #d76436;
    margin-right: 18px;
}
.date-time-log {
    font-size: 16px;
    font-weight: normal;
    color: #131410;
    font-family: 'LexendDeca';
}

.detail-log {
    margin-left: 34px;
    color: #6c6c6c;
    font-size: 16px;
}
</style>
